// extracted by mini-css-extract-plugin
export default {"form-container":"EmailLogPage_form-container__EB+mq","middle-div-container":"EmailLogPage_middle-div-container__9eIZl","table-container":"EmailLogPage_table-container__ISQ-M"};